import { MdGpsFixed } from "react-icons/md";
import Sat from "../assets/sateliteDeTulancingo.png"
import { BsFillRouterFill } from "react-icons/bs";
import { PiSecurityCameraFill } from "react-icons/pi";
import { motion } from "framer-motion";

const Services = () => {
    return (
        <motion.div
            className="grid grid-cols-1 py-12 px-6 gap-6"
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
        >
            <h1 className="text-5xl font-bold text-center">Nuestros Servicios</h1>
            <section className="grid grid-cols-1 md:grid-cols-2 place-content-center items-center">
                <div>
                    <img src={Sat} alt="satelite" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col items-start gap-4">
                        <MdGpsFixed size={44} className="text-red-600" />
                        <h2 className="text-lg font-semibold">
                            Rastreo de vehículos y mercancías vía GPS
                        </h2>
                        <p className="text-gray-500 text-sm">
                            Con nuestra plataforma ahorrará tiempo cuando más lo necesita: al atender a sus clientes,
                            utilizamos tecnología de la red satelital y celular por lo que puede localizar y
                            realizar seguimiento en tiempo real de cualquier unidad a través de nuestra robusta plataforma.
                        </p>
                    </div>
                    <div className="flex flex-col items-start gap-4">
                        <BsFillRouterFill size={44} className="text-red-600" />
                        <h2 className="text-xl font-semibold">
                            Servicios de Renta de wifi portátil
                        </h2>
                        <p className="text-gray-500 text-sm">
                            Nuestros equipos te garantizan Internet portátil para llevar contigo ¡a donde quieras!
                        </p>
                    </div>
                    <div className="flex flex-col items-start gap-4">
                        <PiSecurityCameraFill size={44} className="text-red-600" />
                        <h2 className="text-xl font-semibold">
                            Servicio Renta de cámaras de vigilancia
                        </h2>
                        <p className="text-gray-500 text-sm">
                            Protege lo que más te importa con nuestras cámaras de vigilancia en renta. Ofrecemos equipos modernos,
                            con monitoreo en tiempo real desde tu celular o computadora, ideales para eventos, hogares, negocios o proyectos temporales.
                        </p>
                    </div>
                </div>
            </section>
        </motion.div>
    );
};

export default Services;